// Resolve the API base URL.
// - On Emergent preview / internal hosts: use REACT_APP_BACKEND_URL (set at build).
// - On a custom production domain (e.g. ancienneposteentrechaux.com): use same-origin
//   to avoid Safari ITP / cross-origin issues that block cookies and certain CORS calls.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function resolveApiBase() {
  if (typeof window === "undefined") return `${BACKEND_URL}/api`;
  const host = window.location.hostname;
  const isEmergentHost =
    host.endsWith("emergentagent.com") ||
    host.endsWith("emergent.host") ||
    host === "localhost";
  if (isEmergentHost) return `${BACKEND_URL}/api`;
  return `${window.location.origin}/api`;
}

export const API = resolveApiBase();
